import React from 'react'
import styles from './Overlay.module.scss'

interface OverlayProps {
  visible: boolean
  onClick: () => void
  className?: never
}

export const Overlay: React.FC<OverlayProps> = ({ visible, onClick }) => {
  if (!visible) return null
  return (
    <div
      className={styles.overlay}
      onClick={onClick}
      role="presentation"
      aria-hidden="true"
    />
  )
}
